<div class="profile-content-item profile-top-sec k-d-flex k-gap-5">
  <app-avatar [imageUrl]="userData?.imageUrl" size="xl"></app-avatar>
  <div class="profile-child-content">
    <h3 class="title-sm title-sm">{{userData?.name}}</h3>
    <p class="profile-desc body-md font-color-secondary k-mt-0.5">{{userData?.position}}</p>
    <div class="profile-info-lists k-d-flex k-flex-wrap k-gap-y-3 k-mt-2">
      <div class="list-item k-d-flex k-align-items-center k-gap-2">
        <span class="list-item-icon k-d-flex">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M3.86333 4.2041H16.1358C16.8892 4.2041 17.5 4.81493 17.5 5.56827V14.4316C17.5 15.1849 16.8892 15.7949 16.1367 15.7949H3.86333C3.11083 15.7958 2.5 15.1849 2.5 14.4316V5.56827C2.5 4.81493 3.11083 4.2041 3.86333 4.2041Z"
              stroke="#333F50" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M2.59766 5.06245L9.00932 9.64828C9.58849 10.0624 10.3668 10.0633 10.9468 9.64995L17.3952 5.05078"
              stroke="#333F50" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
        <p class="body-sm font-weight-500 k-flex-1">{{userData?.email}}</p>
      </div>
      <div class="list-item k-d-flex k-align-items-center k-gap-2">
        <span class="list-item-icon k-d-flex">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M9.04451 10.9533C8.06951 9.97831 7.33451 8.88664 6.84618 7.77914C6.74284 7.54497 6.80368 7.27081 6.98451 7.08997L7.66701 6.40831C8.22618 5.84914 8.22618 5.05831 7.73784 4.56997L6.75951 3.59164C6.10868 2.94081 5.05368 2.94081 4.40284 3.59164L3.85951 4.13497C3.24201 4.75247 2.98451 5.64331 3.15118 6.52664C3.56284 8.70414 4.82784 11.0883 6.86868 13.1291C8.90951 15.17 11.2937 16.435 13.4712 16.8466C14.3545 17.0133 15.2453 16.7558 15.8628 16.1383L16.4053 15.5958C17.0562 14.945 17.0562 13.89 16.4053 13.2391L15.4278 12.2616C14.9395 11.7733 14.1478 11.7733 13.6603 12.2616L12.9078 13.015C12.727 13.1958 12.4528 13.2566 12.2187 13.1533C11.1112 12.6641 10.0195 11.9283 9.04451 10.9533Z"
              stroke="#333F50" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
        <p class="body-sm font-weight-500 k-flex-1">{{userData?.phone}}</p>
      </div>
      <div class="list-item k-d-flex k-align-items-center k-gap-2">
        <span class="list-item-icon k-d-flex">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M10 10.8335V10.8335C8.61917 10.8335 7.5 9.71433 7.5 8.3335V8.3335C7.5 6.95266 8.61917 5.8335 10 5.8335V5.8335C11.3808 5.8335 12.5 6.95266 12.5 8.3335V8.3335C12.5 9.71433 11.3808 10.8335 10 10.8335Z"
              stroke="#333F50" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M10.0013 17.5C10.0013 17.5 4.16797 12.7083 4.16797 8.33333C4.16797 5.11167 6.77964 2.5 10.0013 2.5C13.223 2.5 15.8346 5.11167 15.8346 8.33333C15.8346 12.7083 10.0013 17.5 10.0013 17.5Z"
              stroke="#333F50" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
        <p class="body-sm font-weight-500 k-flex-1">{{userData?.location}}</p>
      </div>
    </div>
  </div>
</div>

<div class="profile-content-item">
  <h3 class="title-sm">My Interest</h3>
  <p class="profile-desc body-md font-color-secondary k-mt-0.5">Your passions and professional interests </p>

  @for (interests of myInterests; track $index) {
  <h4 class="title-xs font-weight-700 k-mt-6">{{interests.title}}</h4>
  <div class="k-d-flex k-flex-wrap k-gap-2 k-align-items-center k-mt-3">
    @for (item of interests.items; track $index) {
    <app-tag theme="default" size="lg">{{item}}</app-tag>
    }
  </div>
  }
</div>

<div class="profile-content-item">
  <h3 class="title-sm">Social media</h3>
  <p class="profile-desc body-md font-color-secondary k-mt-0.5">Social media links</p>

  <div class="k-d-flex k-flex-wrap k-gap-x-16 k-gap-y-4 k-mt-6">
    <div class="k-d-flex k-flex-column">
      <p class="body-sm font-color-secondary">Secondary email</p>
      <h5 class="title-sm font-weight-700">audriannap2&#64;everyeng.com</h5>
    </div>
    <div class="k-d-flex k-flex-column">
      <p class="body-sm font-color-secondary">Website</p>
      <h5 class="title-sm font-weight-700">www.audriannaphilips.com</h5>
    </div>
  </div>

  <div class="social-meida-container k-mt-8">
    <p class="body-sm font-color-secondary">Social media profile links</p>

    <ul class="social-media-links">
      @for (socialLink of socialLinks; track $index) {
      <li class="k-mt-1">
        <a class="social-media-link-item k-d-flex k-align-items-center k-gap-4" [href]="socialLink.url" target="_blank">
          <span class="body-sm font-weight-500">{{socialLink.name}}</span>
          <span class="goto-icon k-d-flex k-ml-auto">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M14.125 5.875L5.875 14.125" stroke="#323232" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M8.33203 5.83325L14.1237 5.87409L14.1654 11.6666" stroke="#323232" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
        </a>
      </li>
      }
    </ul>
  </div>
</div>
